import React, { useState, useEffect } from 'react';
import styles from './S_DateBirthPopup.module.css';
import O_Calendar from '@/components/O_Organisms/O_Calendar/O_Calendar';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';

interface S_DateBirthPopupProps {
  setIsDateBirthPopupOpen: (isOpen: boolean) => void;
  onSelectDate?: (date: Date) => void;
  initialDate?: Date;
}

export default function S_DateBirthPopup({
  setIsDateBirthPopupOpen,
  onSelectDate,
  initialDate,
}: S_DateBirthPopupProps) {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const [date, setDate] = useState<Date | undefined>(initialDate);

  useEffect(() => {
    setDate(initialDate);
  }, [initialDate]);

  const handleClosePopup = () => {
    setIsDateBirthPopupOpen(false);
  };

  const handleSelectDate = (selectedDate: Date) => {
    setDate(selectedDate);
    onSelectDate?.(selectedDate);
    setIsDateBirthPopupOpen(false);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.wrapper}>
        <h4 className={styles.title}>{t('profileTab.birthday')}</h4>
        <O_Calendar value={date} onChange={handleSelectDate} />
        <A_Button
          variant='tertiary'
          size='small'
          fontSize='text-p-4'
          onClick={handleClosePopup}
        >
          {t('common.close')}
        </A_Button>
      </div>
    </div>
  );
}
